export const environment = {
    production: false,
    apiURL: "https://bsl-uat-apim.azure-api.net/adminapi/", //NOTE: this is sample api. please replace it with your api url.
    appLogoPath: "assets/images/softweb-logo.svg"
};